/** @format */

import { NotificationsList, selectNotifications } from "./notificationsSlice";
import { ToastContainer } from "react-bootstrap";
import { useSelector } from "react-redux";
import ToastItem from "./ToastItem";
import { UuidString } from "../../types";

/**
        store.dispatch(
          setAddNotifications({
            date: new Date().toISOString(),
            id: "storageIssue",
            title: "Error saving to browser",
            msg:
              "There was an error saving to your browser. You may need to delete some old resources to free up space. " +
              e?.message,
            type: "danger",
          }),
        );
 */

const Notifications = () => {
  const notifications: NotificationsList = useSelector(selectNotifications());
  return (
    <ToastContainer
      className="position-fixed p-4"
      position="bottom-end"
      style={{ zIndex: 10 }}
    >
      {notifications.map((item) => (
        <ToastItem
          {...item}
          id={item.id}
          key={crypto.randomUUID() as UuidString}
        />
      ))}
    </ToastContainer>
  );
};

export default Notifications;
